import Error from 'custom-error';
import Swal from 'sweetalert2';

const fileInputStatus = {
  Empty: 'empty',
  Loaded: 'loaded',
  Loading: 'loading',
  Deleted: 'deleted'
};

const SwAlert = {
  data: () => ({}),
  methods: {
    ShowToast: (Title, Message, MsjType, Callback) => {
      const defautlTitle = {
        success: 'Proceso exitoso',
        warning: 'Atención',
        error: 'Error'
      };
      let title = Title ? Title : defautlTitle[MsjType];
      const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 6000,
        onOpen: Callback
      });
      Toast.fire(title, Message, MsjType);
    },
    ShowAlert: (Title, Message, MsjType, Callback) => {
      Swal.fire({
        title: Title,
        text: Message,
        icon: MsjType,
        allowOutsideClick: false,
        onClose: Callback
      });
    },

    ShowModalComponents(ComponentName) {
      Swal.fire({
        html: ComponentName
      });
    },

    ShowConfirm: async (title, Question) => {
      let answer = false;
      await Swal.fire({
        title: title,
        text: Question,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "No",
        confirmButtonText: "Si"
      }).then(function (response) {
        if (response.value) {
          answer = response.value;
        }
      });
      return answer;
    },
    ShowCancelModal: async (title, message, confirmButtonText = "Sí", cancelButtonText = "No") => {
      let answer = false;
      await Swal.fire({
        title: "",
        html: `
                    <div class="custom-cancel-popup">
                    <div class="header shadow">
                        <div class="title">
                            <div class="icon-container">
                              <i class="fas fa-bell-exclamation circle-icon"></i>
                            </div>
                            <span>${title}</span>
                        </div>
                    </div>
                    <div class="body mt-5">
                        <div class="content py-3 px-4">
                            <span >${message}</span>
                        </div>
                    </div>
                </div>
                    `,
        icon: "warning",
        focusConfirm: false,
        focusCancel: false,
        showCancelButton: true,
        showConfirmButton: true,
        showCloseButton: false,
        allowOutsideClick: false,
        confirmButtonColor: "#2DB782",
        cancelButtonColor: "#D01C1C",
        confirmButtonText: confirmButtonText,
        cancelButtonText: cancelButtonText,
        customClass: "custom-cancel-popup"
      }).then(function (response) {
        if (response.value) {
          answer = response.value;
        }
      });
      return answer;
    },
    ShowAlertModal: (Title, Message, MsjType, Callback) => {
      let icon = "";

      switch (MsjType) {
        case "success":
          icon = "fa-check circle-icon";
          break;

        case "error":
          icon = "fa-times circle-icon";
          break;

        default:
          icon = "fa-exclamation circle-icon";
      }

      Swal.fire({
        html: `
                    <div class="custom-cancel-popup">
						<div class="header shadow">
							<div class="title">
								<div class="icon-container">
									<i class="fas ${icon}"></i>
								</div>
								<span>${Title}</span>
							</div>
						</div>
						<div class="body mt-5">
							<div class="content py-3 px-4">
								<span>${Message}</span>
							</div>
						</div>
              	  </div>
					`,
        allowOutsideClick: false,
        confirmButtonColor: "#2DB782",
        onClose: Callback,
        showConfirmButton: true,
        customClass: "custom-cancel-popup"
      });
    }
  }
};

//
var script = {
  /** Componente personalizado de entrada de archivos */
  name: "CustomFileInput",
  components: {
    Error
  },
  mixins: [SwAlert],
  props: {
    /** Id del Componente CustomFileInput */
    id: {
      type: String,
      default: null
    },

    /** Control para mostrar texto */
    label: {
      type: String,
      default: ""
    },

    /** Control para posicionar texto */
    labelPosition: {
      type: String,
      default: "center"
    },

    /**Texto de referencia para el CustomFileInput */
    placeholder: {
      type: String,
      default: ""
    },

    /** V-model Parámetro de entrada del CustomFileInput */
    value: {
      type: File,
      default: null
    },

    /**Estado del archivo adjunto ejemplo: Loading, Loader, Deleted*/
    attachmentStatus: {
      type: String,
      default: fileInputStatus.Empty
    },

    /** Control para aceptar archivos */
    accept: {
      type: String,
      default: "*"
    },

    /** Estable selección múltiple */
    multiple: {
      type: Boolean,
      default: false
    },

    /** Estado requerido */
    required: {
      type: String,
      default: function () {
        return "";
      }
    },

    /**Estado Error */
    error: {
      type: String,
      default: ""
    },

    /** Mensaje de error encontrado */
    customErrorMsg: {
      type: String,
      default: function () {
        return this.error;
      }
    },

    /** Mensaje de error para alerta de extensión de archivo incorrecta. */
    fileExtensionErrorMsg: {
      type: String,
      default: null
    },

    /** Deshabilita el control */
    disabled: {
      type: Boolean,
      default: false
    },

    /**Estable estilo de visualización */
    displayStyle: {
      type: String,
      default: "short"
    },

    /** Establece ID de archivo adjunto */
    attachmentId: {
      type: String,
      default: null
    },

    /** Posibilita editar */
    isEdit: {
      type: Boolean,
      default: false
    },

    /** Estable el nombre en el archivo */
    name: {
      type: String,
      default: ""
    },

    /** Establece un tamaño máximo */
    maxSize: {
      //Size in MB
      type: Number,
      default: 10
    },
    onDownload: {
      required: true,
      type: Function,
      default: () => new Promise((resolve, reject) => {
        reject(new Error("Debe implementar la función del API para descargar."));
      })
    }
  },

  data() {
    return {
      currentLoad: "0%",
      status: this.attachmentStatus,
      fileReader: null,
      file: null,
      fileLabel: this.name,
      isDeleting: false,
      fileMaxSize: this.maxSize
    };
  },

  computed: {
    hasShortStyle() {
      return this.displayStyle === "normal";
    },

    isLoadingFile() {
      return this.status === fileInputStatus.Loading;
    },

    filename() {
      var _this$name;

      return ((_this$name = this.name) === null || _this$name === void 0 ? void 0 : _this$name.length) ? this.name : this.fileLabel;
    },

    canDownload() {
      return this.attachmentId != null && this.status != fileInputStatus.Deleted || this.status === fileInputStatus.Loaded && this.fileReader !== null && this.fileReader.result != null || this.isEdit;
    },

    progressLabel() {
      return this.status !== fileInputStatus.Loaded ? "Cargando" : "Completado";
    }

  },
  methods: {
    validateFile(file) {
      //check extension and size
      const filename = file.name;
      const fileExtension = filename.split('.')[filename.split('.').length - 1].toLowerCase();
      const fileSize = (file.size / 1048576).toFixed(2);
      const acceptFileExtensions = this.accept.split(",").map(s => s.replace(".", "").toLowerCase()).filter(s => s);
      let validationResult = true; //validate extension

      if (!acceptFileExtensions.includes(fileExtension)) {
        const errorMessage = this.fileExtensionErrorMsg || `Favor de seleccionar un archivo de tipo ${acceptFileExtensions}.`;
        this.ShowToast("Error", errorMessage, "error");
        validationResult = false;
      } //validate file size in mb


      if (fileSize > this.maxSize) {
        this.ShowToast("Error", `Favor de seleccionar el archivo de tamaño menor o igual a ${this.maxSize}MB.`, "error");
        validationResult = false;
      }

      return validationResult;
    },

    handleFileChange: function (e) {
      if (e.target.files && e.target.files.length > 0) {
        //validate file
        if (!this.validateFile(e.target.files[0])) {
          this.$refs.fileuploadRef.value = null;
          return;
        }

        this.$emit("input", e.target.files[0]);
        this.loadFile();
      }
    },

    downloadFile() {
      if (this.canDownload) {
        if (this.attachmentId && !this.isDeleting) {
          // peiServices.downloadDocumentByAttachmentId(this.attachmentId)
          if ({}.toString.call(this.onDownload) === '[object Function]') {
            this.onDownload(this.attachmentId).catch(() => {
              this.ShowToast('', 'El documento no existe.', 'error');
            });
          }
        } else {
          let a = document.createElement("a");
          document.body.appendChild(a);
          a.style = "display: none";
          let url = this.fileReader.result;
          a.href = url;
          a.download = this.file.name;
          a.click();
          window.URL.revokeObjectURL(url);
        }
      }
    },

    removeFile: function (e) {
      e === null || e === void 0 ? void 0 : e.preventDefault();
      this.$emit("input", null);
      this.$emit("after-remove", this.attachmentId);
      this.currentLoad = "0%";
      this.status = fileInputStatus.Deleted;
      this.fileReader = null;
      this.file = null;
      this.fileLabel = null;
      this.isDeleting = true;
    },

    onLoadProgress(event) {
      let loaded = event.loaded / event.total * 100;
      this.status = fileInputStatus.Loading;
      this.currentLoad = loaded + "%";
    },

    onLoad() {
      this.status = fileInputStatus.Loaded;
    },

    loadFile() {
      let file = this.$el.querySelector("input[type=file]").files[0];
      let reader = new FileReader();
      reader.onprogress = this.onLoadProgress;
      reader.onloadend = this.onLoad;
      reader.addEventListener("onprogress", this.onLoadProgress);

      if (file) {
        reader.readAsDataURL(file);
        this.fileReader = reader;
        this.file = file;
        this.fileLabel = file.name;
      }
    }

  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return (id, style) => addStyle(id, style);
}
let HEAD;
const styles = {};
function addStyle(id, css) {
    const group = isOldIE ? css.media || 'default' : id;
    const style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        let code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                style.element.setAttribute('media', css.media);
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            const index = style.ids.size - 1;
            const textNode = document.createTextNode(code);
            const nodes = style.element.childNodes;
            if (nodes[index])
                style.element.removeChild(nodes[index]);
            if (nodes.length)
                style.element.insertBefore(textNode, nodes[index]);
            else
                style.element.appendChild(textNode);
        }
    }
}

/* script */
const __vue_script__ = script;
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-md-12 col-sm-6"
  }, [_vm.label ? _c('div', {
    class: ["text-" + _vm.labelPosition]
  }, [_c('label', {
    staticClass: "input-label"
  }, [_vm._v(_vm._s(_vm.label))])]) : _vm._e(), _vm._v(" "), !_vm.canDownload && !_vm.disabled ? _c('label', {
    staticClass: "form-control position-relative text-center mb-0 file-input-container",
    class: {
      'was-Invalidated': _vm.error,
      'input-disabled': _vm.disabled
    }
  }, [_c('label', {
    staticClass: "file-select"
  }, [_c('em', {
    staticClass: "fas fa-file-plus pr-4 text-green"
  }), _vm._v(" "), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("Presione aquí para anejar documento")]), _vm._v(" "), _c('input', {
    ref: "fileuploadRef",
    attrs: {
      "type": "file",
      "accept": _vm.accept,
      "disabled": _vm.disabled
    },
    on: {
      "change": _vm.handleFileChange
    }
  })])]) : _vm._e(), _vm._v(" "), _vm.canDownload ? _c('div', {
    staticClass: "d-flex align-items-center w-100 justify-content-start"
  }, [_c('div', {
    staticClass: "font-weight-normal"
  }, [_c('label', {
    staticClass: "circle-green"
  }), _vm._v(" "), _c('label', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.filename) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-row-reverse ml-2",
    class: {
      'button-container': _vm.hasShortStyle
    }
  }, [_c('button', {
    staticClass: "btn outline-danger",
    class: {
      'input-disabled': _vm.disabled
    },
    attrs: {
      "type": "button",
      "disabled": _vm.disabled,
      "hidden": _vm.disabled
    },
    on: {
      "click": _vm.removeFile
    }
  }, [_c('i', {
    staticClass: "fas fa-times-circle"
  }), _vm._v(" "), !_vm.hasShortStyle ? _c('span', {
    staticClass: "ml-1"
  }, [_vm._v("Eliminar")]) : _vm._e()]), _vm._v(" "), _vm.canDownload ? _c('button', {
    staticClass: "btn outline-success mr-2 ml-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.downloadFile
    }
  }, [_c('i', {
    staticClass: "fas fa-file-download"
  }), _vm._v(" "), !_vm.hasShortStyle ? _c('span', {
    staticClass: "ml-1"
  }, [_vm._v("Descargar")]) : _vm._e()]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _vm.error ? _c('error', {
    attrs: {
      "variant": "no-border",
      "message": _vm.customErrorMsg
    }
  }) : _vm._e(), _vm._v(" "), _vm.isLoadingFile && !_vm.disabled ? _c('div', {
    staticClass: "progress mt-2"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-striped bg-success text-center",
    style: {
      width: _vm.currentLoad
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "25",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  }, [_vm._v("\n        " + _vm._s(this.progressLabel) + "\n      ")])]) : _vm._e()], 1)]);
};

var __vue_staticRenderFns__ = [];
/* style */

const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-9965d9b0_0", {
    source: ".file-select[data-v-9965d9b0]{text-align:center;margin-bottom:0!important}button[data-v-9965d9b0]{color:#3f5b60;background-color:#fff;font-family:Lato,sans-serif;font-weight:500;font-size:1rem;text-align:center;border-radius:4px;height:2.375rem;border:1px solid #3f5b60;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;cursor:pointer;padding:5px;padding-left:10px;padding-right:10px;white-space:nowrap}input[type=file][data-v-9965d9b0]{display:none}.success[data-v-9965d9b0]{color:#fff;background-color:#2db782;border-color:#2db782}.outline-success[data-v-9965d9b0]{color:#2db782;background-color:#fff;border-color:#2db782}.danger[data-v-9965d9b0]{color:#fff;background-color:#c9545e;border-color:#c9545e}.outline-danger[data-v-9965d9b0]{color:#c9545e;background-color:#fff;border-color:#c9545e}.outline-danger[data-v-9965d9b0]:hover{background-color:#c9545e;color:#fff}.outline-success[data-v-9965d9b0]:hover{background-color:#2db782;color:#fff}.input-disabled[data-v-9965d9b0]{background-color:#e9ecef;cursor:initial}.button-container button[data-v-9965d9b0]{height:33px;width:33px;padding:0}.file-input-container[data-v-9965d9b0]{height:auto!important}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__ = "data-v-9965d9b0";
/* module identifier */

const __vue_module_identifier__ = undefined;
/* functional template */

const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);

// Import vue component

const install = function installCustomFileInput(Vue) {
  if (install.installed) return;
  install.installed = true;
  Vue.component('CustomFileInput', __vue_component__);
}; // Create module definition for Vue.use()
// to be registered via Vue.use() as well as Vue.component()


__vue_component__.install = install; // Export component by default
// also be used as directives, etc. - eg. import { RollupDemoDirective } from 'rollup-demo';
// export const RollupDemoDirective = component;

export default __vue_component__;
